import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SecurityService } from '../../../core/services/security.service';
import { fadeInOutAnimation } from '@nx-ahs/shared/animations';
import {
	AppSpinnerComponent,
	ConfirmationModalService,
	DbIconComponent,
	ModalTemplateComponent
} from '@nx-ahs/shared/components';
import { MomentPipe } from '@nx-ahs/shared/pipes';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ServerInfo } from '../../security/models/server-info.model';

@Component({
	selector: 'app-server-info',
	templateUrl: './server-info.component.html',
	styleUrls: ['./server-info.component.scss'],
	animations: [fadeInOutAnimation],
	standalone: true,
	imports: [CommonModule, MatTooltipModule, ModalTemplateComponent, AppSpinnerComponent, DbIconComponent, MomentPipe]
})
export class ServerInfoComponent implements OnInit {
	public info: ServerInfo;
	public loading: boolean;
	public reconnecting: boolean;

	constructor(
		private securityService: SecurityService,
		private dialogRef: MatDialogRef<ServerInfoComponent>,
		private snackBar: MatSnackBar,
		private confirmationModalService: ConfirmationModalService
	) {}

	ngOnInit() {
		this.loadData();

		this.dialogRef.keydownEvents().subscribe((event) => {
			if (event.key === 'Escape') {
				this.close();
			}
		});
		this.dialogRef.backdropClick().subscribe(() => {
			this.close();
		});
	}

	public close(): void {
		this.confirmationModalService
			.showConfirmationDialog('Confirm Cancel', 'Click OK to continue')
			.beforeClosed()
			.toPromise()
			.then((result) => {
				if (result) {
					this.dialogRef.close(undefined);
				}
			});
	}

	private loadData(): void {
		this.loading = true;
		this.securityService
			.viewServerInfo()
			.toPromise()
			.then((results) => {
				this.info = results;
			})
			.finally(() => {
				this.loading = false;
			});
	}

	public reconnectSignalR() {
		this.reconnecting = true;

		this.securityService
			.reconnectSignalR()
			.toPromise()
			.then((result) => {
				this.loadData();
				this.snackBar.open(result.result, 'OK', { duration: 5000 });
			})
			.finally(() => {
				this.reconnecting = false;
			});
	}
}
